<div class="col-12"  *ngIf="isMultiple">
    <div class="card">
        <h5>Galleria</h5>
        <p-galleria [value]="images" [responsiveOptions]="galleriaResponsiveOptions"
                    [containerStyle]="{'max-width': '800px', 'margin':'auto'}" [numVisible]="6" [circular]="true">
            <ng-template pTemplate="item" let-item>
                <img [src]="item.itemImageSrc" style="width: auto; display: block;height:400px" (click)="openDialog(item)" />
            </ng-template>
            <ng-template pTemplate="thumbnail" let-item>
                <div class="grid nogutter justify-center">
                    <img [src]="item.thumbnailImageSrc" style="display: block;height:100px"/>
                </div>
            </ng-template>
        </p-galleria>
    </div>
</div>
<div class="col-12" *ngIf="!isMultiple">
    <img [src]="singleImages.itemImageSrc"  [class]="styleClassName"  style="width: 200px; display: block;height:auto" />
</div>
<p-dialog [style]="{minWidth:'40%'}" header="Galerie d'images" [(visible)]="displayDialog" [modal]="true" [closable]="true">
    <div class="col-12">
        <img [src]="ressource?.itemImageSrc" style="width: auto; display: block;height:auto"  />

    </div></p-dialog>
